import { faMap } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';
import { useManageEntityAccessInvitations } from '~/_shared/entityAccess/entityAccessInvitations.hooks';
import { useTranslation } from '~/_shared/utils/hooks';
import { entityAccessLevelToTeamShareMapPermissionTranslation } from '~/clientTeamManagement/teamShareMapModal/teamShareMap.helpers';
import { useEntityAccessReceivedInvitationsSelector } from '~/store/frontendState/entityAccessInvitations/entityAccessInvitations.selectors';
import type { TopUnderbarItem } from '../item/topUnderbarItem.types';
import { renderConfirmation } from './topUnderbarConfirmation.component';

export const useInvitationsTopUnderbarItems = () => {
  const [t] = useTranslation();
  const invitationsData = useEntityAccessReceivedInvitationsSelector();
  const {
    rejectEntityAccessInvitation,
    acceptEntityAccessInvitation,
  } = useManageEntityAccessInvitations();

  const mapInvitationsItems: ReadonlyArray<TopUnderbarItem> = useMemo(() => (
    invitationsData.map((invitation) => (
      renderConfirmation({
        icon: faMap,
        id: `map-invitation-${invitation.id}`,
        text: t('accessInvitations.map.inviteText', {
          userName: invitation.createdBy.name,
          mapSharePermission: entityAccessLevelToTeamShareMapPermissionTranslation(invitation.accessLevel, t),
          mapName: invitation.entityName || t('Unknown'),
        }),
        onConfirm: () => {
          acceptEntityAccessInvitation(invitation.id);
        },
        onDeny: () => {
          rejectEntityAccessInvitation(invitation.id);
        },
      })
    ))
  ), [acceptEntityAccessInvitation, invitationsData, rejectEntityAccessInvitation, t]);

  return useMemo(() => ({
    mapInvitationsItems,
  }), [mapInvitationsItems]);
};
